// test1105
(1105 && 0);
